import {
  createStore,
  Reducer,
  combineReducers,
  applyMiddleware,
  Store,
  compose,
} from 'redux';
import thunk from 'redux-thunk';
import {
  analyticsReducer,
  AnalyticsState,
} from './analytics/analytics.reducer';
import { authReducer, AuthState } from './auth/auth.reducer';
import { orgsReducer, OrgsState } from './orgs/orgs.reducer';
import { usersReducer, UsersState } from './users/users.reducer';

export type RootState = {
  users: UsersState;
  auth: AuthState;
  orgs: OrgsState;
  analytics: AnalyticsState;
};

const rootReducer: Reducer<RootState> = combineReducers({
  users: usersReducer,
  auth: authReducer,
  orgs: orgsReducer,
  analytics: analyticsReducer,
});

export const store: Store<RootState> = createStore(
  rootReducer,
  applyMiddleware(thunk)
  // compose(
  //   applyMiddleware(thunk),
  //   (window as any).__REDUX_DEVTOOLS_EXTENSION__ && // eslint-disable-line
  //     (window as any).__REDUX_DEVTOOLS_EXTENSION__() // eslint-disable-line
  // )
);
